import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext({ settings: {}, subscriptionsEnabled: true, updateSettings: async () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);

  const updateSettings = useCallback(async (patch) => {
    await axios.put(`${API}/settings`, patch, { withCredentials: true });
    setSettings((s) => ({ ...s, ...patch }));
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, subscriptionsEnabled: settings.subscriptions_enabled !== false, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useAppSettings = () => useContext(SettingsContext);
